import theme from '../../base';

const breadcrumb = {
  active: {
    foreground: theme.colors.blues.blue300,
  },
  disabled: {
    foreground: theme.colors.neutrals.gray500,
  },
};

export default breadcrumb;
